import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { NeptuneLogo } from "../../components/neptune/NeptuneMark";

/**
 * Shared cinematic shell for the merchant auth pages (Login, Signup, Reset).
 * Matches the AdminLogin aesthetic but tuned for merchants — eyebrow + headline + glass card.
 */
export default function MerchantAuthLayout({
  eyebrow,
  title,
  subtitle,
  children,
  footer,
  testId,
}) {
  return (
    <main
      data-testid={testId}
      className="min-h-screen bg-[#0a0a0a] text-white font-body relative overflow-hidden flex items-center justify-center px-6 py-16"
    >
      <div className="pointer-events-none absolute -top-40 left-1/2 -translate-x-1/2 h-[600px] w-[1000px] rounded-full bg-[#0055FF]/22 blur-[140px]" />
      <div className="pointer-events-none absolute bottom-[-20%] right-[-10%] h-[400px] w-[400px] rounded-full bg-[#00E5FF]/12 blur-[140px]" />
      <div className="absolute inset-0 subtle-grid pointer-events-none opacity-60" />

      <motion.div
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
        className="relative w-full max-w-md"
      >
        <div className="flex justify-center mb-12">
          <Link to="/" data-testid="merchant-auth-logo">
            <NeptuneLogo height={28} />
          </Link>
        </div>

        <div className="rounded-3xl border border-white/[0.08] bg-gradient-to-b from-white/[0.04] to-white/[0.01] backdrop-blur-2xl p-8 sm:p-10">
          <div className="text-[11px] uppercase tracking-[0.22em] text-zinc-500 text-center">
            — {eyebrow}
          </div>
          <h1 className="font-display mt-3 text-3xl sm:text-4xl font-semibold tracking-tighter chrome-text text-center leading-tight">
            {title}
          </h1>
          {subtitle && (
            <p className="mt-3 text-[14px] text-zinc-400 leading-relaxed text-center">
              {subtitle}
            </p>
          )}

          <div className="mt-8">{children}</div>
        </div>

        {footer && <div className="mt-6 text-center text-[12.5px] text-zinc-500">{footer}</div>}

        <div className="mt-6 text-center">
          <Link
            to="/"
            data-testid="merchant-auth-back-home"
            className="text-[12px] text-zinc-600 hover:text-white transition-colors tracking-[0.06em]"
          >
            ← Back to Neptune
          </Link>
        </div>
      </motion.div>
    </main>
  );
}
